// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function debug(message: string): void {
  // console.log(message)
}
